"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuService = void 0;

var lodash_1 = require("lodash");

var Repository_1 = __importDefault(require("./Repository"));

var entities_1 = require("../../entities");

var LegalizeSDKError_1 = __importDefault(require("../../core/utilities/LegalizeSDKError"));

var MenuService =
/** @class */
function () {
  function MenuService(baseUrl) {
    this.repository = new Repository_1.default(baseUrl);
  }

  MenuService.prototype.checkMenuAvailability = function (marketId, placeId) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, _b, error_1;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _c.trys.push([0, 2,, 3]);

            _a = Boolean;
            _b = lodash_1.get;
            return [4
            /*yield*/
            , this.repository.getUltraSlimMenu(marketId, placeId)];

          case 1:
            return [2
            /*return*/
            , _a.apply(void 0, [_b.apply(void 0, [_c.sent(), "menu.groups[0].skus[0].skuId"])])];

          case 2:
            error_1 = _c.sent();
            return [2
            /*return*/
            , false];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  MenuService.prototype.getGroups = function (marketId, placeId) {
    return this.getMenu({
      input: {
        marketId: marketId,
        placeId: placeId
      }
    });
  };

  MenuService.prototype.getGroupsByCategoryIds = function (marketId, placeId, categoryIds) {
    return this.getMenu({
      input: {
        marketId: marketId,
        placeId: placeId,
        categoryIds: categoryIds
      }
    });
  };

  MenuService.prototype.getGroupsByBrandIds = function (marketId, placeId, brandIds) {
    return this.getMenu({
      input: {
        marketId: marketId,
        placeId: placeId,
        brandIds: brandIds
      }
    });
  };

  MenuService.prototype.getGroupsByBrandAndCategoryIds = function (marketId, placeId, brandIds, categoryIds) {
    return this.getMenu({
      input: {
        marketId: marketId,
        placeId: placeId,
        brandIds: brandIds,
        categoryIds: categoryIds
      }
    });
  };

  MenuService.prototype.getGroupsBySkuIds = function (marketId, placeId, skuIds) {
    return this.getMenu({
      input: {
        marketId: marketId,
        placeId: placeId,
        chosenSkuIds: skuIds
      }
    });
  };

  MenuService.prototype.getProductBySkuId = function (marketId, placeId, skuId) {
    return this.repository.getProductBySkuId(marketId, placeId, skuId).then(function (data) {
      var menuSku = lodash_1.get(data, "menu.groups[0].skus[0]");
      return menuSku ? Promise.resolve(new entities_1.MenuSkuEntity(menuSku)) : Promise.reject(new LegalizeSDKError_1.default("Product not found"));
    });
  };

  MenuService.prototype.getMenu = function (variables) {
    return this.repository.getMenu(variables).then(function (data) {
      return Promise.resolve(lodash_1.get(data, "menu.groups", []).map(function (item) {
        return new entities_1.MenuItemGroupEntity(item);
      }));
    });
  };

  return MenuService;
}();

exports.MenuService = MenuService;